<section>
    <ui-view name="content"></ui-view>
</section>
